export const getLocalDateString = (date = new Date()) => {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

// Sınav tarihi ile bugün arasındaki takvim günü farkı (saat dilimi/saat kaymalarından etkilenmez).
// 0 = sınav günü, 1 = sınavdan bir gün önce, negatif = sınav tarihi geçmiş.
export const getExamDayDiff = (targetExamDate: string) => {
  const [ty, tm, td] = targetExamDate.split('-').map(Number);
  const target = new Date(ty, (tm || 1) - 1, td || 1);
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((target.getTime() - today.getTime()) / 86400000);
};

export const getExamCountdownLabel = (diff: number) => {
  if (diff < 0) return 'Sınav tarihi geçti';
  if (diff === 0) return 'Sınavda Başarılar!';
  return `${diff} Gün Kaldı`;
};

export const formatDateSafe = (
  dateInput: any,
  options?: Intl.DateTimeFormatOptions,
  fallback = 'Tarih Belirtilmedi'
): string => {
  if (!dateInput) return fallback;
  const d = new Date(dateInput);
  if (isNaN(d.getTime())) return fallback;
  return d.toLocaleDateString('tr-TR', options);
};

